function cookieInit() {
  const acceptCookiesBtn = document.getElementById('accept-cookies-btn');
  const cookieDisclaimer = document.querySelector('.cookie-disclaimer');
  
  if (!localStorage.getItem('cookiesAccepted')) {
    cookieDisclaimer.style.display = 'flex';
  }
  
  acceptCookiesBtn.addEventListener('click', function() {
    cookieDisclaimer.style.display = 'none';
    
    localStorage.setItem('cookiesAccepted', true);
  });
}

export { cookieInit }